import React from "react";
import { LemonBranchImg } from "@/components/WatercolourArt";
import { Fleuron } from "@/components/Ornament";
import { ScrollReveal } from "@/components/ScrollReveal";

const GARDEN_WATERCOLOR = "/illustrations/garden_watercolor.png";

/**
 * Page header banner: full-width watercolour of the Roze garden as the background,
 * a soft left-side white wash for legibility, an overline + title + optional lead
 * on the left, and decorative lemon branches in the top corners.
 *
 * Use at the very top of internal pages instead of the old padded-top hero.
 */
export const PageHeaderBanner = ({
  eyebrow,
  title,
  lead,
  testid,
  imgSrc = GARDEN_WATERCOLOR,
  minHeight = "min-h-[64vh] md:min-h-[72vh]",
}) => (
  <section className="relative w-full overflow-hidden" data-testid={testid}>
    {/* Lemon corners over the banner — below fixed header */}
    <LemonBranchImg className="absolute top-24 -left-6 w-44 md:w-56 lg:w-72 opacity-95 pointer-events-none hidden md:block z-10" />
    <LemonBranchImg
      flip
      className="absolute top-24 -right-6 w-44 md:w-56 lg:w-72 opacity-95 pointer-events-none hidden md:block z-10"
    />

    {/* Watercolour garden — full background */}
    <img
      src={imgSrc}
      alt=""
      aria-hidden="true"
      className="absolute inset-0 w-full h-full object-cover select-none pointer-events-none"
    />
    {/* Soft white-to-blue gradient overlay on the left so text stays readable */}
    <div
      aria-hidden="true"
      className="absolute inset-0 pointer-events-none"
      style={{
        background:
          "linear-gradient(90deg, rgba(255,255,255,0.88) 0%, rgba(255,255,255,0.6) 32%, rgba(255,255,255,0.2) 55%, rgba(255,255,255,0) 72%)",
      }}
    />

    {/* Content */}
    <div className={`relative container-roze ${minHeight} flex items-end pb-12 md:pb-20 pt-32 md:pt-40`}>
      <ScrollReveal className="max-w-2xl">
        {eyebrow && (
          <div className="overline mb-5 flex items-center gap-3">
            <Fleuron className="h-3 w-3 text-gold" />
            {eyebrow}
          </div>
        )}
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-light leading-[0.95] tracking-tight">
          {title}
        </h1>
        {lead && (
          <p className="mt-6 text-base md:text-lg text-foreground/80 leading-relaxed max-w-xl font-light italic">
            {lead}
          </p>
        )}
      </ScrollReveal>
    </div>
  </section>
);

export default PageHeaderBanner;
